module.exports = __webpack_public_path__ + "img/1487173107.a4837932.jpg";